import React from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {ThemeProvider} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import MobileSvg from "../../components/svg/mobileSvg";
import WebSvg from "../../components/svg/webSvg";

function WhatWeDo({classes, headline}) {
    return (
        <div className={`${classes.root2}`} id={"whatWeDo"}>
            <Grid container direction="row-reverse" justify="center" alignItems="center">
                <Grid container direction="column" justify="center" alignItems="center" item lg={6} xs={12}>
                    <Paper className={`${classes.paper1} `} style={{margin: "30px 0"}}>
                        <ThemeProvider theme={headline}>
                            <Typography variant={"h3"} style={{color: "white"}}
                                        data-aos="animation-right"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                What We Do?
                            </Typography>
                            <Typography variant={"h6"} align={"justify"}
                                        style={{color: "white", textIndent: "50px", margin: "10px"}}
                                        data-aos="animation-right"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                At CODEX, we develop innovative and creative products and services that will satisfy
                                clients.
                                The general purpose of CODEX is to develop and stimulate advanced information
                                technologies for multi-user operation.
                                We promise to handover unique applications, addressing the specific business needs
                                of our clients.
                            </Typography>
                            <Typography variant={"h6"} align={"justify"}
                                        style={{color: "white", textIndent: "50px", margin: "10px"}}
                                        data-aos="animation-right"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                We are focused on building an innovation mindset based on superior achievement,
                                teamwork, respect and recognition, diversified and challenging work and flexible
                                and rewarding career opportunities for our customers.
                            </Typography>
                        </ThemeProvider>
                    </Paper>
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center" item lg={3} xs={12}
                      data-aos="animation-left"
                    // data-aos-offset="200"
                    // data-aos-delay="100"
                      data-aos-duration="1000"
                >
                    <Paper className={`${classes.paper2} card`}>
                        <div className={`face front ${classes.whatWeDoCardFront}`}>
                            <MobileSvg/>
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"}>
                                    Mobile Application
                                </Typography>
                            </ThemeProvider>
                        </div>
                        <div className={`face back ${classes.whatWeDoCardBack}`}>
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"} style={{color: "white"}}>
                                    Mobile Application
                                </Typography>
                                <Typography variant={"h5"} align={"justify"} className={"text"}
                                            style={{color: "white", textIndent: "50px"}}>
                                    The process of creating software for smartphones and digital assistants,
                                    most typically for Android and iOS, is known as mobile application development.
                                    The application can be preinstalled, or downloaded from either a mobile app
                                    store,
                                    or be accessible via a mobile web browser.
                                </Typography>

                            </ThemeProvider>
                            {/*<Button color="inherit" className={`${classes.readMore} text`}><span>Read More</span></Button>*/}
                        </div>
                    </Paper>
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center" item lg={3} xs={12}
                      data-aos="animation-left"
                    // data-aos-offset="200"
                      data-aos-delay="100"
                      data-aos-duration="1000"
                >
                    <Paper className={`${classes.paper2} card`}>
                        <div className={`face front ${classes.whatWeDoCardFront}`}>

                            <WebSvg/>
                            {/*<HomeSvg/>*/}
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"}>
                                    Web Application
                                </Typography>
                            </ThemeProvider>
                        </div>
                        <div className={`face back ${classes.whatWeDoCardBack}`}>
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"} style={{color: "white"}}>
                                    Web Application
                                </Typography>
                                <Typography variant={"h5"} align={"justify"} className={"text"}
                                            style={{color: "white", textIndent: "50px"}}>
                                    A web application is an application software that runs on a web server,
                                    as opposed to computer-based software programs that run locally on the device's
                                    operating system.
                                    The user accesses web applications via a web browser with an active network
                                    connection.
                                    These applications are written in a client–server structure, with the client
                                    receiving services.
                                </Typography>

                            </ThemeProvider>
                            {/*<Button color="inherit" className={`${classes.readMore} text`}><span>Read More</span></Button>*/}
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        </div>
    );
}

export default WhatWeDo;